var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box"},[_c('div',{staticClass:"his-order-div"},[_c('OrderList',{attrs:{"code":_vm.code},on:{"loadCode":function($event){return _vm.loadNowCode()}}})],1),_c('div',{staticClass:"emtry-div"}),_c('HistoryOrderTabbar')],1)}
var staticRenderFns = []

export { render, staticRenderFns }